<script lang="ts">
    import { createEventDispatcher } from "svelte";
    import { formsService } from "../services";
    import { v4 as v4uuid } from 'uuid';
    import type { Form } from "../Model/Form";

    export let form: Form;

    const dispatch = createEventDispatcher();
    const inputId = v4uuid();

    async function toggleStatus(form: Form): Promise<void> {
        try {
            if (form.status) {
                await formsService.disableForm(form.id);
                form.status = false;
                dispatch('enabled', form);
            } else {
                await formsService.enableForm(form.id);
                form.status = true;
                dispatch('disabled', form);
            }
        } catch (error) {
            console.error(error);
        }
    }

</script>

<div class="form-check">
    <input type="checkbox" id={inputId} class="form-check-input" checked={form.status} on:change={() => toggleStatus(form)}>
    <label for={inputId} class="form-check-label">Activado</label>
</div>
